export const checkboxHandler = (
  checkboxes: number[] | undefined,
  methodId: number
) => {
  if (!checkboxes) return [];
  if (checkboxes.some((id) => id === methodId)) {
    const index = checkboxes.indexOf(methodId);
    checkboxes.splice(index, 1);
  } else checkboxes.push(methodId);
  return checkboxes;
};
